var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStarChecked = function SvgStarChecked(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m17.4477 7.41675-4.7127-.40895-1.8403-4.33296c-.3311-.7887-1.46055-.7887-1.7916 0l-1.8403 4.3427-4.70297.39921c-.85685.06816-1.20738 1.13923-.55501 1.70398l3.57348 3.09637-1.07107 4.5959c-.19474.8373.7108 1.4995 1.45082 1.0516l3.81078-2.2957c-.29274-.5466-.32378-1.1959-.09313-1.7643l-3.33791 2.0152.9737-4.1675-3.23268-2.80421 4.2648-.37 1.65529-3.92401 1.665 3.93374 4.2648.37001-3.2327 2.80427.287 1.2282c.058.0467.114.097.1679.1508l1.0318 1.0319.5421-.5432-.3053-1.3127 3.5735-3.09637c.6524-.56475.3116-1.63582-.5453-1.70398zm1.9693 4.49985-.075-.075c-.325-.325-.8583-.325-1.175.0084l-3.9833 3.9916-1.9167-1.9166c-.325-.325-.85-.325-1.175 0l-.075.075c-.325.325-.325.85 0 1.175l2.575 2.575c.325.325.85.325 1.175 0l4.65-4.6584c.325-.325.325-.85 0-1.175z",
    fill: "#777776",
    fillRule: "evenodd"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStarChecked, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/star_checked.40dd286f.svg";
export { ForwardRef as ReactComponent };